<template>
  <section class="page-container">
    <div>
      <h1>Campaigns</h1>
      <div
        class="btn-top-container">
        <v-button
          v-if="activeTab=='Travel'"
          type="plain"
          size="mini"
          @click="handlerToExportList"
        >Export List
        </v-button>
        <v-button
          v-if="active == 'Purchases'"
          type="plain"
          size="mini"
          @click="hanldeImport"
        >Import
        </v-button>
        <v-button
          v-if="showExportBtn"
          type="plain"
          size="mini"
          :disabled="exportDisable"
          @click="handlerDown"
        >Export Excel
        </v-button>
      </div>
    </div>
    <el-tabs
      v-model="active"
      @tab-click="changeTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab"
        :name="tab"
      >
        <span slot="label">
          <span class="flex">
            <span>{{tab}}</span>
            <el-badge
              v-if="tab=='PV Renew Promo'"
              :value="pendingNum"
              :max="99"
              class="aside-dot"
              :class="{'is-update':true}">
            </el-badge>
          </span>
        </span>
      </el-tab-pane>
    </el-tabs>
    <purchase-list
      v-if="active == 'Purchases'"
      ref="Purchases"
      @changeDate='setExportStatus'></purchase-list>
    <hd-list
      v-if="active == 'HD Redeem'"
      ref="HDRedeem"
      @changeDate='setExportStatus'></hd-list>
    <kflm-list
      v-if="active == 'KFLM'"
      ref="KFLM"
      @changeDate='setExportStatus'></kflm-list>
    <gift-pack-list
      v-if="active == 'Gift Pack'"
      ref="GiftPack"
      @changeDate='setExportStatus'></gift-pack-list>
    <talk-list
      v-if="active == 'Referrer Talks'"
      ref="ReferrerTalks"
      @changeDate='setExportStatus'></talk-list>
    <partner-links
      v-if="active == 'Partner Links'"
      ref="PartnerLinks"
      @changeDate='setExportStatus'></partner-links>
    <exclusive-reward-list
      v-if="active == 'HANBERG Card'"
      ref="HANBERGCard"
      @changeDate='setExportStatus'></exclusive-reward-list>
    <promo-hzmb-list
      v-if="active == 'HZMB'"
      ref="HZMB"
      @changeDate='setExportStatus'>
    </promo-hzmb-list>
    <refer-bonus-list  v-if="active == 'Referrer Bonus'">
    </refer-bonus-list>
    <hanger-cashback-list
      v-if="active == 'HANBERG Cashback'"
      ref="HANBERGCashback"
      @changeDate='setExportStatus'
    ></hanger-cashback-list>
    <welcome-offer-list
      v-if="active == 'Welcome Offer'"
      ref="WelcomeOffer"
      @changeDate='setExportStatus'
    ></welcome-offer-list>
    <travel-list
      v-if="activeTab=='Travel'"
      ref="AnnualTravelGift"
      @changeDate='setExportStatus'></travel-list>
    <free-list
      v-if="activeTab=='Free-Round-Trip'"
      ref="Free-Round-Trip"></free-list>
    <flight-delay-list
      v-if="activeTab=='$200 Flight Delay'"
      ref="$200FlightDelay"></flight-delay-list>
    <pv-renew-promo
      v-if="activeTab=='PV Renew Promo'"
      ref="PVRenewPromo"
      @changeDate='setExportStatus'></pv-renew-promo>
  </section>
</template>

<script>
import purchaseList from './components/purchase-list'
import KflmList from './components/KFLM-list'
import HdList from './components/hd-list'
import GiftPackList from './components/gift-pack-list.vue'
import TalkList from './components/referrer-talks-list.vue'
import PartnerLinks from './components/partner-links-list.vue'
import ExclusiveRewardList from './components/exclusive-reward-list.vue'
import PromoHzmbList from './components/promo-hzmb/promo-hzmb-list.vue'
import ReferBonusList from './components/refer-bonus-list'
import HangerCashbackList from './components/cashback/hangerCashbackList'
import WelcomeOfferList from './components/welcome-offer/list'
import travelList from './components/annual-travel/list'
import freeList from './components/free-trip/list'
import flightDelayList from './components/flightDelay/index'
import PvRenewPromo from './components/pvRenewPromo/list'
import {mapActions, mapState} from 'vuex'
import {getListCount, logout} from '@api'

export default {
  name: 'Policy',
  components:{
    purchaseList,
    KflmList,
    HdList,
    GiftPackList,
    TalkList,
    PartnerLinks,
    ExclusiveRewardList,
    PromoHzmbList,
    ReferBonusList,
    HangerCashbackList,
    WelcomeOfferList,
    travelList,
    freeList,
    flightDelayList,
    PvRenewPromo
  },
  data() {
    return{
      countList:{},
      exportDisable: true,
      active: 'Purchases',
      tabList:['PV Renew Promo','$200 Flight Delay','Purchases','HD Redeem','KFLM', 'Gift Pack','Travel','Free-Round-Trip','Welcome Offer', 'HANBERG Card','HZMB','HANBERG Cashback']
    }
  },
  computed:{
    ...mapState('micropolicy',['activeTab']),
    showExportBtn(){
      return !['Referrer Talks','Partner Links','Referrer Bonus','Welcome Offer','Free-Round-Trip'].includes(this.active)
    },
    pendingNum(){
      let {pv_renew_pending_num} = this.countList||{}
      return pv_renew_pending_num||0
    }
  },
  watch:{
    activeTab:{
      immediate: true,
      handler(val) {
        if(val){
          this.active =val
        }
      }
    }
  },
  mounted() {
    this.network().getListCount()
  },
  methods: {
    ...mapActions('micropolicy',['setActiveTab']),
    handlerToExportList(){
      this.$router.push('/admin-cms/marketing-report?name=list')
    },
    handlerDown() {
      let name = this.active.replace(/\s*/g,'')
      this.$refs[name].handlerDown()
    },
    hanldeImport(){
      this.$router.push({
        path: '/records/micropolicy/import-tracking-number'
      })
    },

    setExportStatus(val){
      this.exportDisable = val.length == 0
    },

    changeTab(){
      this.setActiveTab(this.active)
      this.exportDisable = true
    },
    network() {
      return {
        getListCount: async () => {
          let {data} = await getListCount()
          this.countList = data
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container{
  position: relative;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .aside-dot{
    //height: 20px;
    //width: 20px;
    //font-size: 12px;
    //letter-spacing: 0;
    //line-height: 16px;
    //text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left:8px;
    ::v-deep .el-badge__content{
      color: #24292E;
      border:1px solid #E1E4E8;
      background: #FFFFFF;
    }
    &.is-update{
      ::v-deep .el-badge__content{
        color: #fff;
        border:0;
        background-color: #0366D6;
      }
    }
    &.is-info{
      ::v-deep .el-badge__content{
        color: #24292E;
        border:0;
        background: rgba(209, 213, 218, 0.5);
      }
    }
  }
}
</style>
